import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { useFormState } from 'react-final-form';
import { connect } from 'react-redux';

import { isEmpty } from '~/utils';

import { Question } from '../question/Question';

import styles from './QuestionsGroup.scss';

import { OCAB_QUESTION_TYPE } from '../helpers/builder';

export class QuestionsGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visibleQuestions: props.visibleQuestions || [],
    };
  }

  static getDerivedStateFromProps(props, { visibleQuestions: stateVisibleQuestions }) {
    const {
      question,
      questionAnswer: definition,
      visibleQuestions,
      addQuestionsNames,
      removeQuestionsNames,
    } = props;

    const { options, children } = question;

    const childrenNames = children.map((el) => el.reduxFieldConfig.name);
    if (visibleQuestions !== stateVisibleQuestions) {
      const filteredQuestions = children.filter(({ displayCondition }) => {
        let isVisible = false;
        const selectedOptionsKeys = Object.keys(displayCondition.selectedOptions);

        if (definition) {
          if (options.length) {
            const answeredOption =
              question.type === OCAB_QUESTION_TYPE.CHECKBOXES
                ? options.filter(({ displayName }) => definition.includes(displayName))
                : options.find(({ displayName }) => definition.indexOf(displayName) !== -1);

            if (answeredOption) {
              isVisible =
                question.type === OCAB_QUESTION_TYPE.CHECKBOXES
                  ? answeredOption.some((option) => selectedOptionsKeys.includes(option.id))
                  : selectedOptionsKeys.indexOf(answeredOption.id) !== -1;
            }
          } else if (selectedOptionsKeys.length) {
            isVisible = !!definition[0];
          } else {
            isVisible = !definition[0];
          }
        }
        return isVisible;
      });

      if (isEmpty(filteredQuestions)) {
        removeQuestionsNames(childrenNames);
      } else {
        addQuestionsNames(childrenNames);
      }

      return {
        visibleQuestions: filteredQuestions,
      };
    }

    return {};
  }

  render() {
    const { visibleQuestions } = this.state;
    const { editMode, sectionTitle, question, formSectionName } = this.props;

    return (
      <Fragment>
        <div className={styles.MainQuestion}>
          <Question
            question={question}
            editMode={editMode}
            sectionTitle={sectionTitle}
            formSectionName={formSectionName}
            key={question.id}
          />
        </div>

        {visibleQuestions.map((visibleQuestion) => (
          <Question
            question={visibleQuestion}
            editMode={editMode}
            sectionTitle={sectionTitle}
            formSectionName={formSectionName}
            key={visibleQuestion.id}
          />
        ))}
      </Fragment>
    );
  }
}

// Wrapper component to access form state from react-final-form
const QuestionsGroupWithFormState = (props) => {
  const formState = useFormState({ subscription: { values: true } });
  const {
    question: {
      reduxFieldConfig: { name },
    },
    formSectionName,
    questionAnswer,
  } = props;

  const questionAnswerFromForm = questionAnswer || formState.values?.[formSectionName]?.[name];

  return <QuestionsGroup {...props} questionAnswer={questionAnswerFromForm} />;
};

QuestionsGroupWithFormState.propTypes = {
  question: PropTypes.shape({
    reduxFieldConfig: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  formSectionName: PropTypes.string,
  questionAnswer: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.shape({})])),
    PropTypes.string,
  ]),
};

export const ConnectedQuestionsGroup = connect()(QuestionsGroupWithFormState);

QuestionsGroup.propTypes = {
  addQuestionsNames: PropTypes.func,
  removeQuestionsNames: PropTypes.func,
  visibleQuestions: PropTypes.arrayOf(PropTypes.shape({})),
  questionAnswer: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.shape({})])),
    PropTypes.string,
  ]),
  question: PropTypes.shape({
    children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        displayName: PropTypes.string,
      }),
    ),
  }).isRequired,
  editMode: PropTypes.bool,
  sectionTitle: PropTypes.string,
};

QuestionsGroup.defaultProps = {
  visibleQuestions: undefined,
  questionAnswer: undefined,
  editMode: false,
  sectionTitle: '',
};
